import { LeadFormSection } from "@/components/LeadFormSection";
import { SEO } from "@/components/SEO";
import { Phone, Mail, Clock } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const Contact = () => {
  return (
    <>
      <SEO 
        title="Contact Leaf Rush | Book Your Lawn Care Website Strategy Call"
        description="Schedule a free strategy call for your lawn care or landscaping website. Get a site designed to bring you more clients. $0 upfront."
        keywords="lawn care website consultation, landscaping website design quote, lawn care web design contact"
        canonical="https://www.leafrushmarketing.com/contact/"
        ogUrl="https://www.leafrushmarketing.com/contact/"
      />
      <div className="flex flex-col">
      {/* Hero */}
      <section className="py-20">
        <div className="container px-4 md:px-6">
          <div className="mx-auto max-w-4xl text-center space-y-6">
            <h1 className="text-4xl md:text-6xl font-bold tracking-tight">
              Let's <span className="text-primary">Grow</span> Your Business
            </h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Ready to get a high-converting website for your lawn care or landscaping business? 
              Fill out the form below or schedule a free strategy call.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-12">
        <div className="container px-4 md:px-6">
          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <Card>
              <CardContent className="pt-6 text-center">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
                  <Phone className="h-6 w-6 text-primary" />
                </div>
                <h3 className="font-semibold mb-2">Call Us</h3>
                <a
                  href="tel:862-777-2808"
                  className="text-primary hover:underline"
                >
                  862-777-2808
                </a>
                <p className="text-sm text-muted-foreground mt-2">
                  Mon-Fri, 9am-5pm ET
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="pt-6 text-center">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
                  <Mail className="h-6 w-6 text-primary" />
                </div>
                <h3 className="font-semibold mb-2">Email Us</h3>
                <a
                  href="mailto:brandon@leafrushmarketing.com"
                  className="text-primary hover:underline break-all"
                >
                  brandon@leafrushmarketing.com
                </a>
                <p className="text-sm text-muted-foreground mt-2">
                  We reply within 24 hours
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="pt-6 text-center">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
                  <Clock className="h-6 w-6 text-primary" />
                </div>
                <h3 className="font-semibold mb-2">Response Time</h3>
                <p className="text-primary font-semibold">
                  Usually within 2 hours
                </p>
                <p className="text-sm text-muted-foreground mt-2">
                  During business hours
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Lead Form + Calendly */}
      <LeadFormSection />

      {/* FAQ Quick Answers */}
      <section className="py-20 bg-accent/20">
        <div className="container px-4 md:px-6">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-4">Quick Answers Before You Call</h2>
            </div>

            <div className="space-y-6">
              <Card>
                <CardContent className="pt-6">
                  <h3 className="font-semibold text-lg mb-2">How long does it take to build a website?</h3>
                  <p className="text-muted-foreground">
                    About two weeks from kickoff to launch if you provide content and feedback promptly. 
                    Most projects complete in 10–14 days.
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="pt-6">
                  <h3 className="font-semibold text-lg mb-2">What do you need from me to get started?</h3>
                  <p className="text-muted-foreground">
                    Your business info, service descriptions, photos (before/after work is great), 
                    any testimonials, and your goals. We'll guide you through everything on the discovery call.
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="pt-6">
                  <h3 className="font-semibold text-lg mb-2">Do you offer payment plans?</h3>
                  <p className="text-muted-foreground">
                    Yes, we offer flexible payment options. We also have seasonal pricing 
                    (up to 30% off during fall/winter). We'll discuss options on your strategy call.
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="pt-6">
                  <h3 className="font-semibold text-lg mb-2">Can you help with marketing after the website?</h3>
                  <p className="text-muted-foreground">
                    Absolutely. After your website is live, we offer Google Ads management 
                    and Google Business Profile optimization to scale your lead generation.
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>
      </div>
    </>
  );
};

export default Contact;
